import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  IconButton,
  Icon,
  TextField,
} from "@mui/material";
import LGAutocomplete from "../../../atoms/Common/LGAutocomplete.tsx";
import { getProductList } from "../../../api/products";
import { FastField, useFormikContext } from "formik";
import { LGNumber } from "../../../atoms/Inputs/LGNumber.tsx";

interface FormValues {
  outbound: {
    companyId: number | null;
    warehouseOriginId: number | null;
    workOrder: string;
    plantDestinationId: number | null;
    requestedBy: string;
    deliveredBy: string | null;
    deliveryDate: string | null;
    notes: string | null;
  };
  outboundItems: Array<{
    productId: number | null;
    quantity: number;
    workOrder: string | null;
    description: string | null;
    weight: number | null;
  }>;
}

interface OutboundItemsProps {
  formMode: string;
  companyId?: number;
}

const OutboundItems: React.FC<OutboundItemsProps> = ({
  formMode,
  companyId,
}) => {
  const [items, setItems] = useState<any[]>([]);
  const { values, setFieldValue } = useFormikContext<FormValues>();

  const handleAddItem = () => {
    const newItem = {
      productId: null,
      quantity: 0,
      workOrder: "",
      description: "",
      weight: null,
    };

    setItems((prev) => [...prev, newItem]);

    // Also update the formik values
    const currentItems = values.outboundItems || [];
    setFieldValue("outboundItems", [...currentItems, newItem]);
  };

  useEffect(() => {
    // Sync items with Formik values in edit mode or when items are loaded
    if (formMode === "edit" || (values.outboundItems && values.outboundItems.length > 0)) {
      setItems(values.outboundItems || []);
    }
  }, [formMode, values.outboundItems]);

  const handleRemoveItem = (index: number) => {
    const newItems = [...items];
    newItems.splice(index, 1);
    setItems(newItems);

    // Update formik values
    setFieldValue("outboundItems", newItems);
  };

  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Productos
      </Typography>
      {items.map((item, index) => (
        <Box
          pb={2}
          m={1}
          key={index}
          sx={{ border: "1px solid #aaaaaa", borderRadius: 1, p: 2 }}
        >
          <Grid container spacing={2}>
            <Grid item xs={11}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <LGAutocomplete
                    fetchFunction={getProductList}
                    optionLabel={["code", "description"]}
                    optionSeparator=" -- "
                    queryParams={companyId ? { companyId } : {}}
                    onChange={(event, value) => {
                      setFieldValue(
                        `outboundItems[${index}].productId`,
                        value ? value.id : null
                      );
                    }}
                    label="Producto"
                  />
                </Grid>

                <Grid item xs={3}>
                  <FastField
                    name={`outboundItems[${index}].workOrder`}
                    as={TextField}
                    label="Orden de Trabajo"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={3}>
                  <FastField
                    name={`outboundItems[${index}].quantity`}
                    as={LGNumber}
                    label="Cantidad"
                    type="number"
                    fullWidth
                  />
                </Grid>

                <Grid item xs={3}>
                  <FastField
                    name={`outboundItems[${index}].weight`}
                    as={LGNumber}
                    label="Peso (kg)"
                    type="number"
                    fullWidth
                  />
                </Grid>
                
                <Grid item xs={12}>
                  <FastField
                    name={`outboundItems[${index}].description`}
                    as={TextField}
                    label="Descripción"
                    multiline
                    rows={2}
                    variant="outlined"
                    fullWidth
                    margin="normal"
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={1}>
              <IconButton onClick={() => handleRemoveItem(index)} color="error">
                <Icon>delete</Icon>
              </IconButton>
            </Grid>
          </Grid>
        </Box>
      ))}
      <Button variant="contained" onClick={handleAddItem}>
        Agregar producto
      </Button>
    </Box>
  );
};

export default OutboundItems;

